import React, { Component } from 'react';

// import { API, Auth } from "aws-amplify";

// import { Layout, Menu, Breadcrumb, Icon } from 'antd';
import { Card } from 'antd';
import { PageHeader, Button } from 'antd';

import CategoryNewPageComponentContainer from '../../../components/pages/dashboard/categories/CategoryNewPageComponent';

// const { Header, Content, Footer, Sider } = Layout;
// const { SubMenu } = Menu;

class CategoryNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  // handle_show_all = () => {
  //   this.props.history.push(`/categories/list/`);
  // }

  handle_new_categories = () => {
    this.props.history.push(`/categories/new`);
  }

  render() {
    // console.log(this.state);
    return (

      <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
        <PageHeader
          style={{
            paddingLeft: 0,
            borderBottom: '1px solid rgb(235, 237, 240)',
            marginBottom: 16
          }}
          title="Create New Category"
        />
        <Card
          style={{ minHeight: 360 }}
          title="Create a New Category Record via these simple steps"
          extra={[
            <React.Fragment>
              {
                <span>
                  <Button disabled key="1" onClick={this.handle_show_all}>
                    Show All
                  </Button>
                  <Button key="2" disabled onClick={this.handle_new_categories}>
                    New Tags
                  </Button>
                </span>
              }
            </React.Fragment>

          ]}
        >
          <div style={{ paddingTop: 24 }}>
            <CategoryNewPageComponentContainer />
          </div>
        </Card>
      </div>


    );
  }
}

export default CategoryNewPage;
